import InvitationApi from '../api/routes/InvitationApi';

export interface InvitationValidationResult {
    isValid: boolean;
    email: string;
    fullName: string;
    errorMessage: string;
}

const validate = async (token: string): Promise<InvitationValidationResult> => {
    const { data } = await InvitationApi.validate(token);
    return data;
};

const accept = async (token: string, password: string): Promise<void> => {
    await InvitationApi.accept(token, password);
};

const InvitationService = { validate, accept };
export default InvitationService;
